var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Toolbar',{attrs:{"handle-submit":_vm.onSendForm,"handle-reset":_vm.resetForm}}),_c('LocalisationForm',{ref:"createForm",attrs:{"values":_vm.item,"errors":_vm.violations}}),_c('Loading',{attrs:{"visible":_vm.isLoading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }